// @flow
import React, { Fragment } from 'react';
import { Icon } from '@finect/tabular-components/Icon';
import { Flex } from '@finect/tabular-core/Flex';
import { Trash2 } from '@finect/tabular-icons/trash2';
import {
  ArticleContentComments,
  CommentsInner,
  NewComment,
  NewCommentInput,
  Textarea,
  CommentButton,
  NewCommentContent,
  Comments,
  LoadMore,
  NewComentContentImage,
  Comment
} from '../../../../components';
import { UploadImageModal } from './UploadImageModal';

type Props = {
  me: Object,
  comments: Array<Object>,
  loading: boolean,
  paging: Object,
  onLoadMore: Function,
  onPublish: Function
};

type State = {
  following: boolean,
  disabled: boolean,
  show: boolean,
  value: string,
  maxHeight: number | 'auto',
  image: Object,
  isError: boolean
};

export class ArticleComments extends React.Component<Props, State> {
  newCommentInput: HTMLInputElement | null;
  commentBlock: HTMLElement | null;

  state = {
    following: false,
    disabled: true,
    show: false,
    value: '',
    maxHeight: 0,
    image: null,
    isError: false
  };

  /* Enviar comentario paginar adjuntar imagen en el envio */

  handleChange = (event: any) => {
    this.setState({ value: event.target.value });
    this.setState({ disabled: !event.target.value.length });
    if (this.newCommentInput) {
      this.newCommentInput.style.height = '96px';
      this.newCommentInput.style.height = `${this.newCommentInput.scrollHeight}px`;
    }
  };

  handleComment = () => {
    const body = this.state.value;
    const image = this.state.image ? this.state.image.image : '';
    if (!this.state.disabled) {
      this.props.onPublish(body, image);
      this.setState({ value: '', image: null });
      this.setState({ disabled: true });
    } else {
      return false;
    }
  };

  handleOpenImageModal = () => {
    this.setState({ show: true });
  };

  handleCloseImageModal = () => {
    this.setState({ show: false });
  };

  handleUploadImage = (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    fetch(`https://${process.env.FINECT_BASEURL || 'www.finect.com'}/services/image/genericimage.php`, {
      method: 'POST',
      body: formData,
      credentials: 'include'
    })
      .then(response => response.json())
      .then((response) => {
        if (response.error.length === 0) {
          this.setState({ isError: false });
          this.setCommentImage(response);
        }
        if (response.error.length !== 0) {
          this.setState({ isError: true });
        }
      });
  };

  setCommentImage = (response: Object) => {
    this.setState({ image: response });
    this.setState({ show: false });
  };

  handleRemoveImage = () => {
    this.setState({ image: null });
  };

  toggleComments = () => {
    const { maxHeight } = this.state;

    if (this.commentBlock) {
      this.setState({
        maxHeight: maxHeight !== 0 ? 0 : this.commentBlock.scrollHeight
      });

      setTimeout(() => {
        window.scrollTo({
          // $FlowFixMe
          top: this.commentBlock && this.commentBlock.offsetTop - 90,
          left: 0,
          behavior: 'smooth'
        });

        if (navigator.userAgent.indexOf('MSIE') > 0 || navigator.userAgent.indexOf('Edge') > 0) {
          window.scrollTo(0, this.commentBlock && this.commentBlock.offsetTop - 90);
        }
      }, 300);
    }
  };

  render() {
    const { comments, onLoadMore, paging, loading, block } = this.props;
    const { maxHeight, show, image, isError } = this.state;

    const prev = paging.links.find(link => link.rel === 'prev');
    const remainingCommentsQty = paging.totalItems - comments.length;

    return (
      <div>
        <ArticleContentComments id="comentarios">
          <div>
            <strong>{paging.totalItems} Comentarios</strong>
            {!block && (
              <span onClick={this.toggleComments}>
                {comments.length === 0 ?
                  'Sé el primero en comentar'
                  : (
                    <Fragment>{maxHeight === 0 ? 'Mostrar comentarios' : 'Ocultar comentarios'}</Fragment>
                  )}
              </span>
            )}
          </div>
        </ArticleContentComments>

        <Comments ref={el => (this.commentBlock = el)} maxHeight={maxHeight}>
          <CommentsInner>
            {prev ? (
              <LoadMore light onClick={onLoadMore} loading={loading}>
                Ver comentarios anteriores ({remainingCommentsQty})
              </LoadMore>
            ) : null}

            {comments.map(comment => (
              <Comment key={comment.id} comment={comment} />
            ))}

            {!block && (
              <NewComment>
                {show ? (
                  <UploadImageModal
                    show={show}
                    onCloseModal={this.handleCloseImageModal}
                    onUploadImage={this.handleUploadImage}
                    isError={isError}
                  />
                ) : null}
                <Icon
                  size={1}
                  alt="User"
                  image={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}${this.props.me.avatarURL}`}
                  margin="0 12px 0 0"
                />
                <NewCommentInput>
                  <NewCommentContent height={image ? image.heigth : '0'}>
                    {image ? (
                      <NewComentContentImage>
                        <img src={`https://${process.env.FINECT_BASEURL || 'www.finect.com'}/image/${image.image}`} />
                        <span onClick={this.handleRemoveImage}>
                          <Trash2 />
                        </span>
                      </NewComentContentImage>
                    ) : null}
                    <Textarea
                      ref={el => (this.newCommentInput = el)}
                      onChange={this.handleChange}
                      placeholder="¿Tú qué opinas?"
                      value={this.state.value}
                    />
                  </NewCommentContent>
                  <Flex align="flex-end" justify="flex-end">
                    <CommentButton disabled={image} onClick={this.handleOpenImageModal}>
                      Adjuntar imagen
                    </CommentButton>
                    <CommentButton disabled={this.state.disabled} onClick={this.handleComment}>
                      Comentar
                    </CommentButton>
                  </Flex>
                </NewCommentInput>
              </NewComment>
            )}
          </CommentsInner>
        </Comments>
      </div>
    );
  }
}
